import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css";
import config from '../../temp/config';
import AppConstants from '../../app-constants/App_Constants';
import REST_Config from '../../config/config';
import './custom-swagger.css'

const DocumentContentSwagger = (props) => {
  let str = props.fields.documentFile.value;
  
  function getPosition(str, subString, index) {
    return str.split(subString, index).join(subString).length;
  }
  
  let fPos = getPosition(str, '"', 1)
  let sPos = getPosition(str, '"', 2)
  
  
  // console.log(str.slice(fPos+1,sPos))
  return (
  <div>
    <SwaggerUI
              url={`${config.sitecoreApiHost}${REST_Config.SWAGGER_REST_URL}/${str.slice(fPos + 1, sPos)}?sc_lang=en&sc_apikey=${config.sitecoreApiKey}`} />
  </div>
)
  };

export default DocumentContentSwagger;
